module.exports = __webpack_public_path__ + "static/img/zaunshi.3c4b862.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/zaunshi.gif
// module id = nKHs
// module chunks = 56